'use strict';

const $ = require('jquery');
const Cookie = require('./../lib/cookies');

class NoticeBanner {

    constructor() {

        let $noticeBanner = $('#notice-bar');
        let $noticeBtn = $('#notice-btn');
        
        if (Cookie.read("noticeDismissed") !== "true") {
            $noticeBanner.css("display", "block");
        }
        
        $noticeBtn.on("click", function() {
            $noticeBanner.css("display", "none");
            Cookie.create("noticeDismissed", "true", 30); // Cookie expires in 30 days
        });

    }

}

module.exports = NoticeBanner;
